import { isArray } from 'lodash';
import createAction from '../../services/create-action';
import { getValue, getValues } from '../../services/wix-data';
export const FETCH_WIX_DATA_REQUEST = 'wixData/FETCH_REQUEST';
export const FETCH_WIX_DATA_SUCCESS = 'wixData/FETCH_SUCCESS';
export const FETCH_WIX_DATA_FAILURE = 'wixData/FETCH_FAILURE';
export const fetchWixDataRequest = createAction(FETCH_WIX_DATA_REQUEST);
export const fetchWixDataSuccess = createAction(FETCH_WIX_DATA_SUCCESS);
export const fetchWixDataFailure = createAction(FETCH_WIX_DATA_FAILURE);
export const fetchWixData = (Wix, key) => (dispatch) => {
    dispatch(fetchWixDataRequest(key));
    const promise = isArray(key) ? getValues(Wix, key) : getValue(Wix, key);
    return promise
        .then((response) => dispatch(fetchWixDataSuccess(response)))
        .catch((error) => dispatch(fetchWixDataFailure(error)));
};
//# sourceMappingURL=fetch-wix-data.js.map